import { Mapper } from '../services/Mapper'
import { Geocoder } from '../services/Geocoder'

export default {
  searchMarker: null,

  data() {
    return {
      searchText: null,
      submitSearchText: null,
      searchResults: null,
      showingRecentPlaces: false,
      errorMessages: [],
      validationRules: [this.locationChange]
    }
  },
  props: {
    isVisible: Boolean
  },

  watch: {
    isVisible: function() {
      if (this.isVisible) {
        this.focusSearchField()
      }
    }
  },
  methods: {
    focusSearchField() {
      this.$refs.searchField.focus()
    },

    locationChange() {
      if (
        this.submitSearchText &&
        this.searchText !== this.submitSearchText
      ) {
        this.clearResults()
      }

      if (!this.searchText) {
        this.getSavedPlaces()
      }

      return true
    },

    getSavedPlaces() {
      this.searchResults = this.$storage.get('places')
      this.showingRecentPlaces = !!this.searchResults
    },

    submitLocation() {
      this.submitSearchText = this.searchText

      if (!this.searchText) {
        this.getSavedPlaces()
        return
      }

      this.showingRecentPlaces = false

      this.geocoder
        .search(this.searchText)
        .then(data => {
          this.handleResults(data)
        })
        .catch(error => {
          console.log(error)
        })
    },

    selectResult(item) {
      if (!this.$storage.get('pinMarkers', false)) {
        this.mapper.removeAllMarkers()
      }

      this.searchMarker = this.mapper.addMarker(
        item.lon,
        item.lat,
        item.displayText,
        item.icon,
        item.iconClass
      )

      if (item.boundingbox && !item.zoom) {
        let box = item.boundingbox
        let bounds = [
          { lat: box[0], lng: box[2] },
          { lat: box[1], lng: box[3] }
        ]
        this.mapper.fitBounds(bounds)
      } else {
        const zoom = item.zoom ? item.zoom : 15
        const options = { center: { lng: item.lon, lat: item.lat }, zoom }
        this.mapper.flyTo(options)
      }

      this.saveResult(item)
      this.$emit('update:show-drawer', false)
    },

    saveResult(item) {
      if (!this.searchText) {
        return
      }

      const storedItem = this.getStoredItem(item)
      const places = this.$storage.get('places') || []
      const index = places.findIndex(
        place => item.displayText === place.displayText
      )

      if (index === -1) {
        places.unshift(storedItem)
      } else {
        places[index] = storedItem
      }

      if (places.length > 20) {
        places.length = 20
      }

      // store results for 2 days due to geocoder restrictions
      this.$storage.set('places', places, { ttl: 2 * 60 * 60 * 24 * 1000 })
    },

    clearResults() {
      this.submitSearchText = null
      this.searchResults = null
      this.errorMessages = []
    },

    getStoredItem(item) {
      return {
        lon: item.lon,
        lat: item.lat,
        displayText: item.displayText,
        title: item.title,
        subtitle: item.subtitle,
        icon: item.icon,
        iconClass: item.iconClass
      }
    },

    handleResults(data) {
      this.searchResults = data

      if (!this.searchResults || !this.searchResults.length) {
        this.errorMessages = ['No results found']
      }
    },

    // eslint-disable-next-line no-unused-vars
    handleError(err) {
      // console.log('Error searching location: ' + err)
      this.errorMessages = ['Error searching location']
    }
  },
  created() {
    this.mapper = Mapper.instance
    this.geocoder = Geocoder.instance

    this.getSavedPlaces()
  }
}
